import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Injectable()
export class CreateProjectService {

    private projectsUrl = globals.APIURL + '/projects';
    private dupcheckUrl = this.projectsUrl + '/dupcheck';
    private processUrl = this.projectsUrl + '/process';
    private recipeUrl = globals.APIURL + '/admin/recipe';

    constructor(private http: Http, public authHttp: AuthHttp) { }

    convertModelToProject(project: any, projectdetails: any): Observable<string> {
        console.log('convertModelToProject service called');
        let date = new Date();
        let currentTime = date.toISOString();
        let timestamp = new Date();
        let body = JSON.stringify({
          project: {
            type: 2, name: projectdetails.projectname, number: projectdetails.partnumber, revision: projectdetails.revision,
            description: projectdetails.description, customer_id: projectdetails.customerId, assigned_id: projectdetails.assignedId, material_id: projectdetails.materialId,
            status: projectdetails.statusId, operations: projectdetails.operations, actual_set_time: projectdetails.set_time, actual_run_time: projectdetails.run_time,
            actual_cost: projectdetails.cost, create_date: currentTime
          }
        });

        // let body = JSON.stringify({project: { id: projectdetails.projectid , type: 2}});
        // let body = JSON.stringify({ project: {id: project.id, type: 2}});
        let headers = new Headers({
          'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ body: body, headers: headers });

        return this.authHttp.put(this.projectsUrl + '/' + project.id, body, options)
          .map(this.extractData)
          .catch(this.handleError);
    }

    checkDuplications(duplicationParams: any): Observable<string> {

        let body = JSON.stringify({ name: duplicationParams.name, number: duplicationParams.number, filename: duplicationParams.filename });
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ body: body, headers: headers });
        console.log('Models: OPTIONS =>', options);
        console.log('URL:', this.dupcheckUrl);
        return this.authHttp.post(this.dupcheckUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getFileStatus(fileURL): Observable<string> {
    console.log('getFileStatus service method called');

    // var fileURL = "http://mr2-tenantdata-dev.s3.amazonaws.com/mr2-tenantdata-dev/b858a50b-d878-4758-ad84-73f41aea7274/44/Attachments/WithPMI.png";
    let headers = new Headers({
        'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });

    return this.http.get(fileURL, options)
        .map(this.responseReturn)
        .catch(this.handleError);
    }

    DeleteProjectAttachmentFile(deleteFileUrl): Observable<{}> {
        // var deleteFileUrl = "http://mr2-tenantdata-dev.s3.amazonaws.com/mr2-tenantdata-dev/b858a50b-d878-4758-ad84-73f41aea7274/44/Attachments/WithPMI.png";
        let headers = new Headers({
        });
        let options = new RequestOptions({ body: '', headers: headers });
        console.log('Projects Attachment: OPTIONS =>', options);
        console.log('DELETE URL:', deleteFileUrl);
        return this.http.delete(deleteFileUrl, options)
          .map(this.extractData)
          .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        // console.log('BODY:', body);
        return body || {};
    }

      handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
          error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

    private responseReturn(res: Response) {
        return {};
    }

    startProcessingUpload(projectid: string, tenantid: string, filename: string, planid: string): Observable<string> {
        console.log('startProcessing service method called');

        let body = JSON.stringify({ projectid: projectid, tenantid: tenantid, filename: filename, planid: planid });
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ body: body, headers: headers });
        console.log('URL =>', this.processUrl);
        console.log('BODY =>', body);
        console.log('OPTIONS =>', options);

        return this.authHttp.post(this.processUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    addProject(file: Array<File>, projectdetails: any): Observable<string> {
        console.log('uploadProject service method called');
        console.log('Project name  : ' + projectdetails.projectname);
        console.log('File array count:', file.length);
        let body;
        if (!projectdetails.material) {
          projectdetails.material = 0;
        }
        if (!projectdetails.customerId) {
          projectdetails.customerId = 0;
        }
        if (!projectdetails.assignedId) {
          projectdetails.assignedId = 0;
        }


        body = JSON.stringify(projectdetails);

        let headers = new Headers({
          'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });

        return this.authHttp.post(this.projectsUrl, body, options)
          .map(this.extractData)
          .catch(this.handleError);
      }

    updateProject(id: number, updateProjectdetails: any): Observable<string> {
        console.log('uploadProject service method called');
        console.log('Project name  : ' + updateProjectdetails.projectname);
        // console.log('File array count:', file.length);

        let body = JSON.stringify({ project: updateProjectdetails });

        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });

        return this.authHttp.put(this.projectsUrl + '/' + id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    addRecipe(recipeValues: any): Observable<string> {

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            recipe: {
            name: recipeValues.name,
            note: recipeValues.note,
            type_id: recipeValues.type_id,
            template_name: recipeValues.template_name,
            project_id: recipeValues.project_id
            },
            template_id: recipeValues.template_id
        });

        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.recipeUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/createproject/createproject.service.ts